import { ReactNode } from 'react';
import { Typography } from '@mui/material';

import { formatPercentage } from './number';

export const getMatchLabel = (match: Disciplines.DisciplineMatch | Majors.MajorMatch | Universities.UniversityMatch): ReactNode => {
  if (match.value > 0) {
    return <Typography component="span" fontSize={12} color={match.isIgnored ? 'textSecondary' : 'primary'}>{formatPercentage(match.value)} Match</Typography>;
  }
  if (match.value < 0) {
    return <Typography component="span" fontSize={12} color={match.isIgnored ? 'textSecondary' : 'error'}>Negative Match</Typography>;
  }
  return <Typography component="span" fontSize={12} color="textSecondary">No Match</Typography>;
};
